<template>
  <v-container v-if="readyForDisplay">
    <v-row>
      <v-col sm="12" md="4">
        <v-card class="mt-6">
          <v-card-title>
            <span class="headline">Property Details</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-expansion-panels multiple v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-header>Investment</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field label="Home Price" required v-model.number="home.Price"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-row>
                          <v-col cols="9">
                            <v-text-field label="Down Payment" required v-model.number="home.DownPayment"
                                          @change="updateData"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-btn icon color="blue" @click="reviseDownPayment">
                              <v-icon>mdi-cached</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="Property Appreciation %" required
                                      v-model.number="home.AppreciationPctAnnual" @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="Mortgage Interest Rate %" required v-model.number="home.InterestRateAnnual"
                                      @change="updateData"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>Income - Monthly</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field label="Monthly Rental" required v-model.number="home.RentalPerMonth"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="Rental Appreciation %" required
                                      v-model.number="home.RentalAppreciationPctAnnual"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="STR Daily Rate" required v-model.number="home.STRAverageDailyRate"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="STR Occupancy %" required v-model.number="home.STROccupancyPct"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="STR Rate Increase %" required v-model.number="home.STRAnnualIncreasePct"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="STR Prop Mgmt %" required v-model.number="home.STRPropertyMgmtPct"
                                      @change="updateData"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>General Expenses - Annual</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field label="Taxes" required v-model.number="home.TaxesAnnual"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="Insurance" required v-model.number="home.InsuranceAnnual"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="Repair Costs" required v-model.number="home.RepairCostsAnnual"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="HOA Fees" required v-model.number="home.HoaAnnual"
                                      @change="updateData"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="Utilities - STR" required v-model.number="home.UtilitiesAnnual"
                                      @change="updateData"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="12" md="8" class="mt-6">
        <v-card class="estimate-card">
          <v-img
              :src="googleAddress"
              class="black--text align-start"
              height="200px">
            <v-card-title>{{ this.home.Address.Street }}, {{ this.home.Address.City }} {{ this.home.Address.State }}
            </v-card-title>
          </v-img>
          <v-card-actions>
            <v-img src="../assets/house-dollar.svg" max-width="30px"></v-img>
            <h3 class="ml-2">${{ this.home.Zestimate }}</h3>
            <v-spacer></v-spacer>
            <span class="caption grey--text font-weight-light">Estimates provided by Zillow.</span>
            <v-spacer></v-spacer>
            <v-img src="../assets/rent.svg" max-width="30px"></v-img>
            <h3 class="ml-2">${{ this.home.RentZestimate }}</h3>
          </v-card-actions>
        </v-card>
        <v-card sm="12" md="8" class="mt-3">
          <v-card-title>Long Term Rental</v-card-title>
          <v-card-actions>
            <v-img src="../assets/profit-dollar-hand.svg" max-width="30px"></v-img>
            <h3 :class="home.PropertyAnalysis.MonthlyProfit > 0 ? 'green--text ml-2': 'red--text ml-2'"
                v-if="this.home.PropertyAnalysis">{{ this.home.PropertyAnalysis.MonthlyProfit | currency }}</h3>
            <v-spacer></v-spacer>
            <h5>With property management: </h5>
            <h3 :class="home.PropertyAnalysis.MonthlyProfitWithPropMgmt > 0 ? 'green--text ml-2': 'red--text ml-2'"
                v-if="this.home.PropertyAnalysis">
              {{ this.home.PropertyAnalysis.MonthlyProfitWithPropMgmt | currency }}</h3>
          </v-card-actions>
          <v-card-text class="pt-5">
            <v-row class="flex-sm-column flex-md-row ml-5 mr-5">
              <v-row class="d-flex flex-column">
                <h4>Monthly Breakdown</h4>
                <table class="breakdown" frame=void rules=rows>
                    <tbody>                      
                      <tr>
                        <td class="label-col">Mortgage Payment</td>
                        <td class="amount-col">-{{ Math.round(this.home.PropertyAnalysis.MortgagePayment) | currency('$', 0) }}</td>
                      </tr>
                      <tr>
                        <td class="label-col">HOA</td>
                        <td class="amount-col">-{{ this.MonthlyBreakdown.hoa | currency('$', 0) }}</td>
                      </tr>
                      <tr>
                        <td class="label-col">Insurance</td>
                        <td class="amount-col">-{{ this.MonthlyBreakdown.insurance | currency('$', 0) }}</td>
                      </tr>
                      <tr>
                        <td class="label-col">Property Taxes</td>
                        <td class="amount-col">-{{ this.MonthlyBreakdown.taxes | currency('$', 0) }}</td>
                      </tr>  
                      <tr>
                        <td class="label-col">Maintenance</td>
                        <td class="amount-col">-{{ this.MonthlyBreakdown.maintenance | currency('$', 0) }}</td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <td class="amount-col"><v-divider class="my-5 border-opacity-100"></v-divider></td>
                      </tr>
                      <tr>
                        <td class="label-col">Total Expenses</td>
                        <td class="amount-col">-{{ (this.MonthlyBreakdown.maintenance + this.MonthlyBreakdown.taxes + this.MonthlyBreakdown.insurance + this.MonthlyBreakdown.hoa + this.home.PropertyAnalysis.MortgagePayment) | currency('$', 0) }}</td>
                      </tr>                    
                    </tbody>                
                  </table>
              </v-row>    
              <v-row class="ml-md-8 flex-column">
                <h4>5 Year ROI</h4>
                <table class="breakdown" frame=void rules=rows>
                  <tbody>
                    <tr>
                      <td class="label-col">Appreciation:</td>
                      <td class="amount-col">{{ ProfitBreakdown.appreciation | currency('$', 0) }}</td>
                    </tr>
                    <tr>
                      <td class="label-col">Principal Savings:</td>
                      <td class="amount-col">{{ ProfitBreakdown.principalSavings | currency('$', 0) }}</td>
                    </tr>
                    <tr>
                      <td class="label-col">Rental Income:</td>
                      <td class="amount-col">{{ ProfitBreakdown.rentalIncome | currency('$', 0) }}</td>
                    </tr>                    
                    <tr>
                      <td class="label-col">Cost of Vacancy:</td>
                      <td class="amount-col">-{{ ProfitBreakdown.costOfVacancy | currency('$', 0) }}</td>
                    </tr>
                    <tr>
                      <td class="label-col">Selling Costs:</td>
                      <td class="amount-col">-{{ ProfitBreakdown.sellingCost | currency('$', 0)}}</td>
                    </tr>                                    
                    <tr>
                      <td>&nbsp;</td>
                      <td class="amount-col"><v-divider class="my-5 border-opacity-100"></v-divider></td>
                    </tr>
                    <tr>
                      <td class="label-col">Net Profit:</td>
                      <td :class="ProfitBreakdown.netProfitWithAppreciation > 0 ? 'amount-col' : 'red--text amount-col'">{{ ProfitBreakdown.netProfitWithAppreciation  | currency('$', 0) }}</td>
                    </tr>
                    <tr>
                      <td class="label-col">
                        Without Appreciation:
                      </td>
                      <td class="amount-col">                        
                        <span
                          :class="ProfitBreakdown.roiPct > 0 ? 'green--text ml-5 font-weight-bold': 'red--text ml-5 font-weight-bold'">{{
                            ProfitBreakdown.roiPct | percent(1,1)
                          }} <span
                            v-if="ProfitBreakdown.roiPct > 0">&#8593;</span><span v-else>&#8595;</span></span>
                      </td>
                    </tr>
                    <tr>
                      <td class="label-col">
                        With Appreciation:
                      </td>
                      <td class="amount-col">
                        <span
                            :class="ProfitBreakdown.roiPctWithAppreciation > 0 ? 'green--text ml-5 font-weight-bold': 'red--text ml-5 font-weight-bold'">{{
                              ProfitBreakdown.roiPctWithAppreciation | percent(1,1)
                            }} 
                        <span v-if="ProfitBreakdown.roiPctWithAppreciation > 0">&#8593;</span><span v-else>&#8595;</span></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-row>
            </v-row>    
            <v-row>                
            </v-row>                    
          </v-card-text>
          <v-card-actions class="pt-2 ml-5 mr-5 d-flex flex-column align-start">
            <div>
              <span>Average return on this investment is </span>
              <span class="green--text font-weight-bold" v-if="ProfitBreakdown.roiPctWithAppreciation >= 50">{{ ProfitBreakdown.roiPctWithAppreciation / 5 | percent(1,1) }}.</span>
              <span class="red--text font-weight-bold" v-else> {{ ProfitBreakdown.roiPctWithAppreciation / 5 | percent(1,1) }}.</span>
              <span> S&P average is 10% per year.</span>
            </div>      
            <div class="mt-5 chart">
              <line-chart :chartData="this.appreciationValues" :baseValue="this.home.DownPayment"
                            v-if="this.appreciationValues" class="chart"></line-chart>              
            </div>      
          </v-card-actions>
        </v-card>
        <v-card sm="12" md="8" class="mt-3">
          <v-card-title>Short Term Rental</v-card-title>
          <v-card-actions>
            <v-img src="../assets/receipt_black_24dp.svg" max-width="30px"></v-img>
            <h3
                v-if="this.home.PropertyAnalysis">{{ this.home.PropertyAnalysis.STRMonthlyIncome | currency }}</h3>
            <v-spacer></v-spacer>
            <h5>Profit: </h5>
            <h3 :class="home.PropertyAnalysis.STRMonthlyProfitWithMgmt > 0 ? 'green--text ml-2': 'red--text ml-2'"
                v-if="this.home.PropertyAnalysis">
              {{ this.home.PropertyAnalysis.STRMonthlyProfitWithMgmt | currency }}</h3>
          </v-card-actions>
          <v-card-text class="pt-5">
            <v-row class="ml-5">
              <v-img src="../assets/growth-1.svg" max-width="20px"></v-img>
              <span class="ml-3">5 Year Average ROI Without Appreciation:</span>
              <span
                :class="strRoi5 > 0 ? 'green--text ml-5 font-weight-bold': 'red--text ml-5 font-weight-bold'">{{
                  strRoi5 | percent(1,1)
                }} <span
                  v-if="strRoi5 > 0">&#8593;</span><span v-else>&#8595;</span></span>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row class="ml-5">
              <v-img src="../assets/growth-2.svg" max-width="20px"></v-img>
              <span class="ml-3">5 Year Average ROI With Appreciation:</span>
              <span
                :class="strRoi5WithAppreciation > 0 ? 'green--text ml-5 font-weight-bold': 'red--text ml-5 font-weight-bold'">{{
                  strRoi5WithAppreciation | percent(1,1)
                }} <span
                  v-if="strRoi5WithAppreciation > 0">&#8593;</span><span v-else>&#8595;</span></span>
            </v-row>
            <v-divider class="my-2"></v-divider>
          </v-card-text>
        </v-card>
        <v-card class="mt-3">
          <div class="d-flex justify-center mt-6">
            <div class="zillow">
              <v-img src="../assets/zillowlogo_200x50.webp"></v-img>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <v-progress-circular v-else
                       :size="50"
                       class="mt-12"
                       color="primary"
                       indeterminate
  ></v-progress-circular>
</template>

<script>
import { db } from '../firebase';
import LineChart from './LineChart';
import MonthlyBreakdown from '@/domain/MonthlyBreakdown';
import ProfitBreakdown from '@/domain/ProfitBreakdown';
import { calculateMetrics, calculateMonthlyBreakdown, calculateProfitBreakdown } from '@/services/AnalyticsService';
import { sessionService } from '@/services/SessionService';
import { authService } from '@/services/AuthService';
import { doc, getDoc, setDoc } from "firebase/firestore";

export default {
  name: 'PropertyDetails.vue',
  components: {
    LineChart
  },
  data() {
    return {
      breakdownYearIndex: 1,
      MonthlyBreakdown: new MonthlyBreakdown(),
      ProfitBreakdown: new ProfitBreakdown(),
      year_5: new Date().getFullYear() + 5 + '',      
      home: {
        Price: null,        
        PropertyAnalysis: {
          RentalAfterExpenses: null,
          MortgagePayment: null,
          MonthlyProfit: null,
          MonthlyProfitWithPropMgmt: null,
          ROI: null,
          ROIWithAppreciation: null,
          STRROI: null,
          STRROIWithAppreciation: null,
          STRMonthlyIncome: null,
          STRMonthlyProfitWithMgmt: null
        }
      },
      distributedSeriesOptions: {
        distributeSeries: true
      },
      sessionService: sessionService,
      authService: authService,
      readyForDisplay: false
    };
  },
  computed: {
    panel: function() {
      return this.$vuetify.breakpoint.mdAndUp ? [0, 1] : [];
    },
    roi5: {
      get: function() {
        return this.home.PropertyAnalysis.ROI[this.year_5] / 5;
      }
    },
    roi5WithAppreciation: {
      get: function() {
        return this.home.PropertyAnalysis.ROIWithAppreciation[this.year_5] / 5;
      }
    },
    appreciationData: {
      get: function() {
        if (this.home.PropertyAnalysis.ROI) {
          return {
            labels: Object.keys(this.home.PropertyAnalysis.ROI),
            datasets: [
              {
                label: 'LTR - Growth',
                backgroundColor: '#789CEA',
                data: Object.values(this.home.PropertyAnalysis.ROI)
              },
              {
                label: 'LTR with appreciation',
                backgroundColor: '#78D5EA',
                data: Object.values(this.home.PropertyAnalysis.ROIWithAppreciation)
              }
            ]
          };
        } else {
          return null;
        }
      }
    },
    strRoi5: {
      get: function() {
        return this.home.PropertyAnalysis.STRROI[this.year_5] / 5;
      }
    },
    strRoi5WithAppreciation: {
      get: function() {
        return this.home.PropertyAnalysis.STRROIWithAppreciation[this.year_5] / 5;
      }
    },
    strAppreciationData: {
      get: function() {
        if (this.home.PropertyAnalysis.STRROI) {
          return {
            labels: Object.keys(this.home.PropertyAnalysis.STRROI),
            datasets: [
              {
                label: 'STR Growth',
                backgroundColor: '#789CEA',
                data: Object.values(this.home.PropertyAnalysis.STRROI)
              },
              {
                label: 'STR with appreciation',
                backgroundColor: '#78D5EA',
                data: Object.values(this.home.PropertyAnalysis.STRROIWithAppreciation)
              }
            ]
          };
        } else {
          return null;
        }
      }
    },
    appreciationValues: {
      get: function() {
        if (this.home.PropertyAnalysis.ROI) {
          return {
            labels: Object.keys(this.home.PropertyAnalysis.ROI),
            datasets: [
              {
                label: 'LTR',
                backgroundColor: 'rgba(30,136,229,0.8)',
                borderColor: '#1E88E5',
                data: Object.values(this.home.PropertyAnalysis.ROI).map(value => ((value / 100) * this.home.DownPayment) + this.home.DownPayment)
              },
              {
                label: 'LTR with appreciation',
                backgroundColor: 'rgba(255,179,0,0.5)',
                borderColor: '#FFB300',
                data: Object.values(this.home.PropertyAnalysis.ROIWithAppreciation).map(value => ((value / 100) * this.home.DownPayment) + this.home.DownPayment)
              }
            ]
          };
        } else {
          return null;
        }
      }
    },
    strAppreciationValues: {
      get: function() {
        if (this.home.PropertyAnalysis.STRROI) {
          return {
            labels: Object.keys(this.home.PropertyAnalysis.STRROI),
            datasets: [
              {
                label: 'STR',
                backgroundColor: 'rgba(120,156,234,0.8)',
                borderColor: '#789CEA',
                data: Object.values(this.home.PropertyAnalysis.STRROI).map(value => ((value / 100) * this.home.DownPayment) + this.home.DownPayment)
              },
              {
                label: 'STR with appreciation',
                backgroundColor: 'rgba(120,213,234,0.5)',
                borderColor: '#78D5EA',
                data: Object.values(this.home.PropertyAnalysis.STRROIWithAppreciation).map(value => ((value / 100) * this.home.DownPayment) + this.home.DownPayment)
              }
            ]
          };
        } else {
          return null;
        }
      }
    },
    googleAddress: {
      get: function() {
        if (this.home.Address) {
          const address = this.home.Address.Street.split(' ').join('+') + '+' + this.home.Address.City + '+' + this.home.Address.State;
          return 'https://maps.googleapis.com/maps/api/staticmap?key=AIzaSyCEihGc3s-2JNISe3LUCzGo998MynRny88&zoom=13&size=640x640&maptype=roadmap&center='
              + address + '&markers=size:mid|color:0x78D5EA|label:|' + address;
        } else {
          return null;
        }
      }
    }
  },
  methods: {
    reviseDownPayment: function() {
      this.home.DownPayment = this.home.Price * .25;
      this.updateData();
    },
    updateData: function() {
      calculateMetrics(this.home);
      calculateMonthlyBreakdown(this.MonthlyBreakdown, this.home, this.breakdownYearIndex)
      calculateProfitBreakdown(this.ProfitBreakdown, this.home, 5)
      this.home.UpdatedAt = new Date().getTime()
      if (this.authService.loggerIn && this.$route.params.id) {
        const docRef = doc(db, "properties", this.$route.params.id);
        setDoc(docRef, this.home);
      }
    },
    setDefaults: function() {
      if (!this.home.STROccupancyPct) {
        this.home.STROccupancyPct = 40;
      }
      if (!this.home.STRAverageDailyRate) {
        this.home.STRAverageDailyRate = Math.round((this.home.RentalPerMonth * 1.4) / 30);
      }
      if (!this.home.STRPropertyMgmtPct) {
        this.home.STRPropertyMgmtPct = 20;
      }
      if (!this.home.STRAnnualIncreasePct) {
        this.home.STRAnnualIncreasePct = 2.5;
      }
      if (!this.home.UtilitiesAnnual) {
        this.home.UtilitiesAnnual = 4000;
      }
    }
  },
  created: function() {
    if (this.$route.params.id) {
      const docRef = doc(db, "properties", this.$route.params.id);
      getDoc(docRef)
        .then((result) => {
          this.home = Object.assign({}, this.home, result.data());
          this.setDefaults();
          calculateMetrics(this.home);
          calculateMonthlyBreakdown(this.MonthlyBreakdown, this.home, this.breakdownYearIndex)
          calculateProfitBreakdown(this.ProfitBreakdown, this.home, 5)
          this.readyForDisplay = true;
        });
    } else {
      this.home = Object.assign({}, this.home, this.sessionService.property.toDTO());
      this.setDefaults();
      calculateMetrics(this.home);
      calculateMonthlyBreakdown(this.MonthlyBreakdown, this.home, this.breakdownYearIndex)
      calculateProfitBreakdown(this.ProfitBreakdown, this.home, 5)
      this.readyForDisplay = true;
    }
  }
};
</script>

<style scoped>
.chart-sheet {
  top: -24px;
  position: relative;
}

.chart {
  height: auto;
  width: 100%;
  position: relative;
  min-height: 250px;
}

.zillow {
  width: 200px;
  height: 50px;
}

.estimate-card {
  align-items: flex-end;
}

.primary-color-text {
  color: #78D5EA;
}

.secondary-color-text {
  color: #789CEA;
}

.breakdown {
  max-width: 400px;
}

.label-col {
  text-align: left;
}

.amount-col {
  padding-left: 30px;
  text-align: right;
  font-weight: bold;
}
</style>
